export default __webpack_public_path__ + "static/media/3fbee6cc969be3cf905e1e9ec4c8812e1581619872740.3c8ff8fd.webp";